import "./components.css";
import { Link } from "react-router-dom";
import { RESERVATIONS_URL } from "../utils/helper";

const Header = ({ activePage }) => {
  return (
    <header className="header frcc w-100 h-80px">
      <div className="header-main frbc">
        <Link to="/">
          <img
            src={`${process.env.PUBLIC_URL}/img/logo.png`}
            alt="Μπαράτσας Καύσιμα"
          />
        </Link>
        <ul className="header-nav frcc">
          <li>
            <a
              className={
                activePage === "Reserve"
                  ? "lh-80px item-active font-bold"
                  : "lh-80px"
              }
              href={RESERVATIONS_URL}
            >
              Ραντεβού
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
